export const WIDTH = 200;
export const HEIGHT = 200;
export const MARGIN = 10;
